<template>
  <el-drawer class="formulaOrder" :visible.sync="visible" :size="970" :withHeader="false" direction="rtl"
    :show-close="false" :wrapperClosable="false" :close-on-press-escape="false" :before-close="close">
    <div class="plate" v-loading="loading">
      <div class="header">
        <div class="header_left">
          <div class="header_title">{{ chargeFlag ? '配方单' : '生成配方单' }}</div>
          <div v-if="!chargeFlag" class="header_title_tips">收费完成后将自动发送至处理医馆！</div>
          <div v-else class="header_title_tips">收费后添加的加工费、快递费，请另行开单收取！</div>
        </div>
        <div class="header_right">
          <el-button v-if="!sourceUniOrderNumber" type="primary" @click="save">保存</el-button>
          <el-button @click="close">取消</el-button>
        </div>
      </div>
      <div class="region">
        <div class="region_left">
          <div class="total">
            <div class="total_item">
              <div class="total_item_label">加工费待收：</div>
              <div class="total_item_value">￥{{ processPrice }}</div>
            </div>
            <div class="total_item">
              <div class="total_item_label">快递费待收：</div>
              <div class="total_item_value">￥{{ deliveryPrice }}</div>
            </div>
          </div>
          <div class="prescription_list">
            <Prescription ref="Prescription" :chargeFlag="chargeFlag" :takeWayList="takeWayList"
              :list="prescriptionList" @loadingChange="loadingChange"></Prescription>
          </div>
        </div>
        <div class="region_right">
          <TakeWay ref="TakeWay" :orderId="orderId" :patientInfo="patientInfo" :chargeFlag="chargeFlag"
            :prescriptionList="prescriptionList" :list="takeWayList" @loadingChange="loadingChange"></TakeWay>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getFormulaOrderInfo, postFormulaOrderInfo } from '@/api/pricingDetails.js';
import Prescription from './Prescription';
import TakeWay from './TakeWay';
export default {
  name: 'FormulaOrder',
  components: {
    Prescription,
    TakeWay
  },
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },
    patientInfo: {
      type: Object,
      default: function () {
        return {
          patientId: ''
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      chargeFlag: false,
      sourceUniOrderNumber: '',
      paidProcessPrice: 0,
      paidDeliveryPrice: 0,
      prescriptionList: [],
      takeWayList: []
    }
  },
  computed: {
    // 加工费计算
    processPrice() {
      let price = 0;
      this.prescriptionList.forEach(v1 => {
        v1.prescriptionPaymentVOS.forEach(v2 => {
          price = price + Number(v2.handlingAmount)
        })
      })
      price = price - Number(this.paidProcessPrice);
      price = Math.round(price * 100) / 100;
      return price;
    },
    // 快递费计算
    deliveryPrice() {
      let price = 0;

      let effectiveTakeWayList = []
      this.prescriptionList.forEach(v1 => {
        v1.prescriptionPaymentVOS.forEach(v2 => {
          if (!effectiveTakeWayList.includes(v2.drugWayId)) {
            effectiveTakeWayList.push(v2.drugWayId)
          }
        })
      })

      this.takeWayList.forEach(v => {
        if (effectiveTakeWayList.includes(v.drugWayId)) {
          price = price + Number(v.deliveryAmount)
        }
      })
      price = price - Number(this.paidDeliveryPrice);
      price = Math.round(price * 100) / 100;
      return price;
    }
  },
  methods: {
    loadingChange(status = false) {
      this.loading = status
    },
    // 计算加工费
    countProcessPrice(prescriptionList) {
      let price = 0;
      prescriptionList.forEach(v1 => {
        v1.prescriptionPaymentVOS.forEach(v2 => {
          price = price + Number(v2.handlingAmount)
        })
      })
      price = Math.round(price * 100) / 100;
      return price;
    },
    // 计算快递费
    countDeliveryPrice(prescriptionList, takeWayList) {
      let price = 0;

      let effectiveTakeWayList = []
      prescriptionList.forEach(v1 => {
        v1.prescriptionPaymentVOS.forEach(v2 => {
          if (!effectiveTakeWayList.includes(v2.drugWayId)) {
            effectiveTakeWayList.push(v2.drugWayId)
          }
        })
      })

      takeWayList.forEach(v => {
        if (effectiveTakeWayList.includes(v.drugWayId)) {
          price = price + Number(v.deliveryAmount)
        }
      })
      price = Math.round(price * 100) / 100;
      return price;
    },
    async open() {
      this.visible = true;
      this.loading = true;
      const res = await getFormulaOrderInfo({ orderId: this.orderId }).catch(() => { return false });
      this.loading = false;
      if (res.code === 200) {
        this.chargeFlag = res.data.chargeFlag;
        this.sourceUniOrderNumber = res.data.sourceUniOrderNumber;
        if (res.data.chargeFlag) {
          this.paidProcessPrice = this.countProcessPrice(res.data.recipeVOS);
          this.paidDeliveryPrice = this.countDeliveryPrice(res.data.recipeVOS, res.data.decoctionCenDrugWayVOS);
        } else {
          this.paidProcessPrice = 0;
          this.paidDeliveryPrice = 0;
        }
        const sortMap = {
          1: 2,
          5: 2,
          4: 1,
          0: 0
        }
        res.data.recipeVOS.sort((a, b) => {
          const aStr = `${sortMap[a.recipeType]}_${a.orderNum}`;
          const bStr = `${sortMap[b.recipeType]}_${b.orderNum}`;
          return aStr < bStr ? -1 : 1
        })
        /**
         * editMapping-params
         * drugEdit: 药品可编辑
         * processEdit: 加工可编辑
         * drugWayEdit: 取药方式可编辑
         * remarkEdit: 备注可编辑
         * handleTimeEdit: 处理时间可编辑
         * handleDeptEdit: 处理医馆可编辑
         * deliveryWayEdit: 取药方式可编辑
         * deliveryEdit: 取药信息可编辑
         * deliveryAmount: 快递费可编辑
         */
        const editMapping = {
          drugEdit: [0, 1, 2],
          processEdit: [0],
          drugWayEdit: [0, 1, 2],
          remarkEdit: [0, 1, 2],
          handleTimeEdit: [0, 1, 2],
          handleDeptEdit: [0, 1, 2],
          deliveryWayEdit: [0],
          deliveryEdit: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          deliveryAmountEdit: [0]
        }
        this.takeWayList = res.data.decoctionCenDrugWayVOS.map(v => {
          if (v.deliveryWay === 1) {
            v['deliveryMemberValue'] = v.delivery && `${v.delivery.consigneeName}${v.delivery.phone}${v.delivery.provinceName}${v.delivery.cityName}${v.delivery.regionName}${v.delivery.scopeName || ''}${v.delivery.detailedAddress}` || '';
          }
          v['takeWayEdit'] = true;
          v['handleTimeEdit'] = true;
          v['handleDeptEdit'] = true;
          v['deliveryWaySelfEdit'] = v.status !== 1;
          v['deliveryWayEdit'] = v.status !== 1;
          v['deliveryEdit'] = v.status !== 1;
          v['deliveryAmountEdit'] = v.status !== 1;
          return v;
        }) || [];
        this.prescriptionList = res.data.recipeVOS.map(v => {
          // v.orderNum = ++typeNum[v.recipeType];
          v.prescriptionPaymentVOS.map(v2 => {
            // 一品多号修改 后端要求取spuTotalQty字段 前端用于非处方和中成药是否算平
            v2.drugs.forEach(v3=>{
              if([1,5].includes(v.recipeType) && !v3.checkStatus){
                v3.drugNum = v3.spuTotalQty
                v3.drugPieceNum = v3.spuItemQty
              }else if(![1,5].includes(v.recipeType)){
                v3.drugNum = v3.spuTotalQty
              }
            })
            // 自定义虚拟id
            v2['virtuallyId'] = v2.id;

            // 编辑状态
            const drugWay = res.data.decoctionCenDrugWayVOS.find(way => { return way.drugWayId === v2.drugWayId });
            if (res.data.chargeFlag) {
              v2['formulaEdit'] = (v2.status === 0 && v2.payStatus !== 3) && [null, undefined, ''].includes(res.data.sourceUniOrderNumber);
              v2['drugEdit'] = editMapping.drugEdit.includes(v2.status) && [0, 1].includes(v2.payStatus) && v.recipeType !== 5;
              v2['processEdit'] = editMapping.processEdit.includes(v2.status) && [null, undefined, ''].includes(v2.handlingWay);
              v2['drugWayEdit'] = editMapping.drugWayEdit.includes(v2.status);
              v2['remarkEdit'] = editMapping.remarkEdit.includes(v2.status);
              if (drugWay) {
                drugWay['takeWayEdit'] = false;
                drugWay['handleTimeEdit'] = drugWay['handleTimeEdit'] === false ? false : editMapping.handleTimeEdit.includes(v2.status);
                drugWay['handleDeptEdit'] = drugWay['handleDeptEdit'] === false ? false : editMapping.handleDeptEdit.includes(v2.status);
                drugWay['deliveryWaySelfEdit'] = !res.data.chargeFlag;
                drugWay['deliveryWayEdit'] = drugWay['deliveryWayEdit'] === false ? false : editMapping.deliveryWayEdit.includes(v2.status);
                drugWay['deliveryEdit'] = drugWay['deliveryEdit'] === false ? false : editMapping.deliveryEdit.includes(v2.status);
                drugWay['deliveryAmountEdit'] = drugWay['deliveryAmountEdit'] === false ? false : (editMapping.deliveryAmountEdit.includes(v2.status) && drugWay.deliveryWay === 0);
              }
            } else {
              v2['formulaEdit'] =  [null, undefined, ''].includes(res.data.sourceUniOrderNumber);
              v2['drugEdit'] = true;
              v2['processEdit'] = true;
              v2['drugWayEdit'] = true;
              v2['remarkEdit'] = true;
              if (drugWay) {
                drugWay['takeWayEdit'] = true;
                drugWay['handleTimeEdit'] = true;
                drugWay['handleDeptEdit'] = true;
                drugWay['deliveryWaySelfEdit'] = true;
                drugWay['deliveryWayEdit'] = true;
                drugWay['deliveryEdit'] = true;
                drugWay['deliveryAmountEdit'] = true;
              }
            }
            // 药品处理
            if (!v2.drugs) {
              v2.drugs = []
            }
            let checkAll = false;
            const allLength = v2.drugs.filter(drug => { return drug.isOwned !== 1 }).length;
            const checkLength = v2.drugs.filter(drug => { return drug.isOwned !== 1 && drug.checkStatus === 1 }).length;
            if (checkLength === allLength) {
              checkAll = true
            }
            v2['checkAll'] = checkAll;
            // 加工方式处理
            if ([null, undefined].includes(v2['handlingWay'])) {
              v2['handlingWay'] = ['']
            } else {
              v2['handlingWay'] = v2['handlingWay'].split('/');
            }

            // 操作日志
            v2['operateLogs'] = (v2['operateLogs'] || []).map(v3=> ({
              ...v3,
              operateData: v3.operateData ? JSON.parse(v3.operateData) : v3.operateData
            }))
            return v2;
          })
          return v;
        }) || [];
      } else {
        this.$message.error(res.message)
      }
    },
    close() {
      this.visible = false;
      this.chargeFlag = false;
      this.paidProcessPrice = 0;
      this.paidDeliveryPrice = 0;
      this.prescriptionList = [];
      this.takeWayList = [];
    },
    async save() {
      const result = await Promise.all([this.$refs['Prescription'].validate(), this.$refs['TakeWay'].validate()]);
      const checkStatus = this.prescriptionList.every(v=>{ return this.$refs['Prescription'].formulaStatus(v).status })
      // 一品多号要求没有配平不能保存
      if(!checkStatus){ return this.$message.error('药品内容未通过！'); }
      if (!result.includes(false)) {
        const recipeReqs = JSON.parse(JSON.stringify(this.prescriptionList));
        const drugWayReqs = JSON.parse(JSON.stringify(this.takeWayList));

        let specialReminderStatus = false;

        recipeReqs.map(v1 => {
          v1.prescriptionPaymentVOS.map(v2 => {
            v2['handlingWay'] = v2['handlingWay'].join('/') || null;
            v2['drugs'] = v2['drugs'].filter(v3 => {
              if ([1, 5].includes(v1.recipeType) && v3.checkStatus === 1) {
                v3.useDrugNum = v3.drugNum
              }
              return v3.checkStatus === 1;
            })
            const drugWay = drugWayReqs.find(v3 => { return v3.drugWayId === v2.drugWayId });
            if (drugWay && (drugWay.transferDeptId !== 127 && drugWay.deliveryWay === 1)) {
              specialReminderStatus = true
            }
            if ([1, 5].includes(v1.recipeType)) {
              const drugWay = drugWayReqs.find(v3 => { return v3.drugWayId === v2.drugWayId });
              if (drugWay && ((v2.handlingWay === null && drugWay.transferDeptId === 127) || (v2.handlingWay !== null && drugWay.transferDeptId !== 127))) {
                specialReminderStatus = true;
              }
            }
          })
        })

        if (specialReminderStatus) {
          const result = await this.$confirm('<div>检测到可能存在以下情况：</div><div>1.分馆处理加工</div><div>2.药事中心处理不加工</div><div>3.分馆处理配送</div>', '提示', {
            confirmButtonText: '坚持选择',
            cancelButtonText: '返回修改',
            // type: 'warning',
            dangerouslyUseHTMLString: true,
          }).then(() => { return true }).catch(() => { return false });

          if (!result) {
            return false;
          }
        }

        let traceCodeDrugList = []
        recipeReqs.forEach(v1 => {
          v1.prescriptionPaymentVOS.forEach((v2, i2) => {
            v2.drugs.forEach(v3 =>{
              if(v3.traceStatus === 1){
                const drugWay = drugWayReqs.find(way => { return way.drugWayId === v2.drugWayId })
                if (drugWay && drugWay.transferDeptId === 127) {
                  traceCodeDrugList.push({ recipeType: v1.recipeType, orderNum: v1.orderNum, formulaIndex: i2, drugName: v3.drugName })
                }
              }
            })
          })
        })
        
        if (traceCodeDrugList.length > 0) {
          const recipeTypeMap = {
            0: '非处方项目',
            1: '中药处方',
            4: '中成药处方',
            5: '医联产品-中药处方'
          }
          const info = traceCodeDrugList[0]
          let text = ''
          if (info.recipeType === 0) {
            text = `${recipeTypeMap[info.recipeType]}-配方单${info.formulaIndex + 1}中的${info.drugName}不允许药事服务中心处理。`
          } else {
            text = `${recipeTypeMap[info.recipeType]}${info.orderNum}-配方单${info.formulaIndex + 1}中的${info.drugName}不允许药事服务中心处理。`
          }
          this.$message.error(text);
          return false
        }

        this.loading = true;

        const res = await postFormulaOrderInfo({
          originalDeptId: sessionStorage.getItem('deptId'),
          orderId: this.orderId,
          recipeReqs: recipeReqs,
          drugWayReqs: drugWayReqs
        })

        this.loading = false;

        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '保存成功！',
            duration: 1000
          });
          this.close();
          this.$emit('success', this.orderId);
        }
      } else {
        this.$message.warning('请完善信息后保存！');
      }
    },
  }
}
</script>

<style lang="less" scoped>
.formulaOrder /deep/ .el-drawer {
  border-radius: 12px 0px 0px 12px;
}

.plate {
  height: 100VH;
  background-color: #FFFFFF;
  overflow: hidden;
}

.header {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #E0E0E0;
}

.header_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.header_title {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}

.header_title_tips {
  margin: 0 0 0 6px;
  font-size: 14px;
  color: #667182;
}

.header_right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.header_right_price {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 16px 0 0;
}

.header_right_price_label {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}

.header_right_price_value {
  font-weight: bold;
  font-size: 16px;
  color: #FE8F1F;
}

.region {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: calc(100VH - 56px);
  overflow: hidden;
}

.region_left {
  flex-grow: 1;
  box-sizing: border-box;
  padding: 16px;
  height: 100%;
  border-right: 1px solid #D8D8DA;
  overflow-x: hidden;
  overflow-y: auto;
}

.total {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #F7F8F8;
  border: 1px solid #D8D8DA;
  border-radius: 2px;
}

.total_item {
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.total>.total_item:first-child {
  border-right: 1px dashed #D8D8DA;
}

.total_item_label {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}

.total_item_value {
  font-weight: bold;
  font-size: 16px;
  color: #FE8F1F;
}

.prescription_list {
  box-sizing: border-box;
  margin: 16px 0 0 0;
  padding: 16px 12px;
  width: 100%;
  background-color: #F7F8F8;
  border: 1px solid #D8D8DA;
  border-radius: 2px;
}

.region_right {
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 16px;
  width: 280px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
